module.exports = __webpack_public_path__ + "img/2.e063b571.png";